import React from 'react';
import swal from 'sweetalert';
import { uploadAdditional, getAuction } from '../../../../../../models/auctions';
import { Spinner } from 'react-bootstrap';
import i18n from '../../../../../../i18n';
import FileInputNew from '../../../../../helpers/fileInputNew';
import { FileText, Download } from 'lucide-react';

const allowedFormats = ['pdf', 'doc', 'docx', 'txt', 'jpg', 'jpeg', 'png', 'bmp', 'gif'];

export class AdditionalTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      auction: {},
      is_loading: false,
      is_loading_additional: false,
      auctionId: props.auctionId,
      file_additional_information: null,
    };
    this.onFileChange = this.onFileChange.bind(this);
  }

  componentDidMount() { this.loadAuction(); }

  onFileChange = (event) => {
    let fmt = event.target.files[0].name.split('.').pop().toLowerCase();
    if (!allowedFormats.includes(fmt)) { swal('Failed', 'Wrong file format', 'error'); return; }
    if (event.target.name === 'file_additional_information') {
      this.setState({ file_additional_information: event.target.files[0] });
      this.uploadFile(event);
    }
  };

  async loadAuction() {
    this.setState({ is_loading: true });
    const response = await getAuction(this.state.auctionId);
    if (response) { this.setState({ auction: response.data, is_loading: false }); }
  }

  async uploadFile(event) {
    event.preventDefault();
    if (!this.state.auctionId || !event.target.files[0].name) { swal('Failed', 'File Missing', 'error'); return; }
    const formData = new FormData();
    this.setState({ is_loading_additional: true });
    formData.append('file_additional_information', event.target.files[0], event.target.files[0].name);
    formData.append('auction_id', this.state.auctionId);
    const response = await uploadAdditional(formData);
    if (response) {
      this.setState({ is_loading_additional: false });
      if (response.success) { this.setState({ auction: response.data }); }
      else { swal('Failed', 'Some error occured!! Please make sure that you are uploading proper file.', 'error'); }
    }
  }

  render() {
    let { auction } = this.state;
    return (
      <div className="form-section">
        <h2><FileText size={20} style={{ marginRight: '8px', verticalAlign: 'text-bottom' }} />Upload Additional Information</h2>
        <p style={{ fontSize: '0.8rem', color: '#6b7280', marginBottom: '16px' }}>
          Allowed Formats: {allowedFormats.join(', ')}
        </p>
        <div className="form-field form-field-margin-bottom">
          <FileInputNew className="form-control" placeholder={i18n.t('choose_file')}
            default_placeholder={i18n.t('choose_file')} id="file_additional_information"
            name="file_additional_information" onChange={this.onFileChange} />
        </div>

        {this.state.is_loading_additional && (
          <div style={{ textAlign: 'center', padding: '1rem', background: '#f9fafb', borderRadius: '8px' }}>
            <Spinner animation="border" />
          </div>
        )}

        {!this.state.is_loading_additional && auction.file_additional_information && (
          <div style={{
            display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px',
            background: '#f9fafb', borderRadius: '8px', border: '1px solid #e5e7eb'
          }}>
            <FileText size={20} style={{ color: '#6b7280' }} />
            <a href={auction.file_additional_information} target="_new" style={{
              color: '#10b981', fontWeight: 500, textDecoration: 'none', display: 'flex',
              alignItems: 'center', gap: '6px'
            }}>
              <Download size={16} /> {i18n.t('view')}/{i18n.t('download')}
            </a>
          </div>
        )}
      </div>
    );
  }
}